export function GetUserDetails() {
    const loginData = localStorage.getItem('loginDetails');
    if (loginData) {
        try {
            return JSON.parse(loginData);
        } catch (error) {
            console.error("Error parsing login data:", error);
            return null;
        }
    }
    return null;
}

export function isValidEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const invalidPattern = /[.]{2,}|[.-]{2,}|[@]{2,}/; // Invalid patterns to check against
    return emailPattern.test(email) && !invalidPattern.test(email);
}

export function isValidName(name) {
    const nameRegex = /^[a-zA-Z0-9_ -]{3,}$/;
    return nameRegex.test(name);
}

export function hasSpecialCharacter(password) {
    const specialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
    return specialCharRegex.test(password);
}